import React from 'react';
import { Link } from '@reach/router';
import Carouselteam from '../components/carouselteam';
import Bannercontact from '../components/bannercontact';
import Pricing from '../components/pricing';
import Testimony from '../components/carouseltestimony';
import Footer from '../components/footer';


export default () => (
  <div>
      <section className='jumbotron breadcumb h-vh' style={{backgroundImage: `url(${'./img/witaly_grpup_header.jpg'})`}}>
        <div className='homebread'>
          <div className='container-fluid'>
            <div className='row m-10-hor'>
              <div className='col-md-8 mr-auto '>
                <div className='heading'>
                  Witaly Group
                </div>
                <div className='content'>
                  We are a conglomerate of 4 companies operating within Italy, 
                  Middle East, and East Africa. We are focused in 4 industries: 
                  Interior Design, Shipping, Hospitality, Waste Management and Sustainability.
                </div>
                <div className="btn" onClick={()=> window.open("/home1", "_self")}>
                  <span className="shine"></span>
                  <span>Contact Us</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='container-fluid black_more'>
        <div className='row m-10-hor'>

          <div className='col-md-5'>
            <div className='heading'>
              Witaly <span className='br'></span> Group
            </div>
            <div className='subheading'>
              According lifestyle
            </div>
          </div>

          <div className='col-md-7'>
            <div className='content'>
              <p>Witaly Group is a trusted logistics and service solutions provider offering a complete
              range of services including clearing and forwarding, warehousing, packing, removals,
              air freight, and sea freight. We help businesses and individuals move goods efficiently</p>
              and safely across local and international markets.<></>

              <p>In addition to logistics, we also provide interior and trading services, giving our clients
              convenient access to quality products and professional solutions under one roof.</p>

              At Witaly Group, we are committed to delivering reliable, efficient, and customer-focused
              services that simplify logistics and support our clients’ growth.
            </div>
            {/* <div className='content'>
              Witaly Group provides a one stop shop for your clearing and forwarding,
              warehousing, packing, removals, airfreight and sea freight solutions.
              Other services include Interior and Trading
            </div> */}
          </div>

        </div>
    </section>

    <section className='container-fluid p-0 black'>
        <div className='row'>

          <div className="col-md-6 pr-md-0">
            <img src="./img/witalyInterior.jpg" className="imgslickz" alt="#"/>
          </div>

          <div className="col-md-6 centered p-5">
            <div className='p-md-5'>
              <div className="subheading">Witaly Group | Development</div>
              <div className="heading">
                Witaly Interior Design
              </div>
              <p className="mt-3">
              Witaly Interior is an interior design brand dedicated to the philosophy 
              that true luxury is found in the perfect balance of form and function.
              By merging modern architectural principles with an unwavering eye for detail,
              Witaly transforms living spaces into serene, high-end retreats.
              </p>
              <Link className='btn' to="">
                <span className="shine"></span>
                <span>More Detail</span>
              </Link>
            </div>
          </div>

          <div className="col-md-6 centered p-5 pb-5">
            <div className='p-md-5'>
              <div className="subheading">Witaly Group | Logisitcs</div>
              <div className="heading">
                Witaly Shipping
              </div>
              <p className="mt-3">
                Witaly Shipping, our commitment to excellence doesn't end at the design studio.
                We ensure that the "Precision" in our name extends to the final arrival of
                your curated pieces, no matter where you are in the world.

                Our specialized logistics team handles every aspect of the shipping process,
                ensuring that high-end furniture and delicate architectural components reach
                their destination in pristine condition.
              </p>
              <Link className='btn' to="">
                <span className="shine"></span>
                <span>More Detail</span>
              </Link>
            </div>
          </div>

          <div className="col-md-6 pl-md-0">
            <img src="./img/witalyShipping.jpg" className="imgslickz" alt="#"/>
          </div>

        </div>
    </section>

    <section className='container-fluid black_more'>
        <div className='row m-10-hor'>
          <div className='col-12 text-center'>
            <div className='subheading'>Witaly Group | Food & Beverage </div>
            <div className='heading'>Lavilla Restaurant</div>
            <div className='row'>
              <div className='col-md-8 mx-auto'>
                <p className='content'>
                  Between a bottle of Italian wine and two close friends,
                  born the vision La Villa Restaurant and Wine bar The deep
                  passion for the Italian cuisine, pushed those friends to
                  open an Italian restaurant in Nairobi with a concept totally
                  different from the standards.... La Villa needed to be an elegant
                  place where any one can taste the traditional Italian cuisine and
                  a range of Italian wines. 
                </p>
              </div>
            </div>
          </div>
          <Carouselteam />
          
        </div>
        
    </section>
    

    <Bannercontact/>
    {/*<Pricing />*/}
    {/*<Testimony />*/}
    <Footer />

  </div>
);
